var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVector57 = function SvgVector57(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.602 9.201h-.471c-.982 0-1.777.796-1.777 1.778v0c0 .981.795 1.777 1.777 1.777h.711a2.489 2.489 0 0 0 2.49-2.489V8.954c0-2.1-1.703-3.801-3.802-3.801h-.95a4.752 4.752 0 0 0-4.752 4.751v1.243a5.995 5.995 0 0 0 6.106 5.994l.895-.017a6.873 6.873 0 0 0 6.745-6.872v-1.18A8.076 8.076 0 0 0 7.5.996h-5.67",
    stroke: "#479DA6",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
};
export default SvgVector57;